export default [
  '#329BFC',
  '#FF9F40',
  '#FF6384',
  '#4BC0C0',
  '#054A29',
  '#9966FF',
  '#D90429',
  '#03045E',
  '#77FF33',
  '#C9CBCF',
  '#FF3333',
  '#240046',
  '#FFE66D',
  '#302B20',
  '#FF006E',
  '#1780A1',
  '#5BBA6F',
  '#BE0AFF',
  '#F4CAE0',
];
